import { Component, OnInit } from '@angular/core';
import { NgForm, FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { BudgetService } from 'src/app/services/budget.service';
import { Budget } from 'src/app/models/budget.model';
import { Upload } from 'src/app/uploads/upload';
import { UploadService } from 'src/app/uploads/upload.service';
import { DatosService } from '../servicios/datos.service';

@Component({
  selector: 'app-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.scss']
})
export class BudgetComponent implements OnInit {
  public budget = new Budget();
  private uploadPath: string;
  public submitted = false;
  private submitting = false;

  myFiles:string [] = [];

  budgetForm = new FormGroup({
    'first_name': new FormControl ('', [
      Validators.required
    ]),
    'surname': new FormControl ('', [
      Validators.required
    ]),
    'phone': new FormControl ('', [
      Validators.required
    ]),
    'email': new FormControl ('',[
      Validators.required
    ]),
    'comment': new FormControl ('', []),
    'upload': new FormControl ('', [Validators.required])
  })

  onSubmit(form: NgForm) {
    this.submitted = true;
    if (!this.submitting && form.valid && (this.budget.services.length > 0)){
      this.submitting = true;
      Object.assign(this.budget, form.value);
      this.budgetService.createBudget(this.budget.asCreateForm()).then((docRef) => {
        this.budget.id = docRef.id;
      }).finally(() => {
        this.submitting = false;
      });
      // this.onReset()
    }
  }
  onFileChange(event) {
    this.budget.photos = [];
    let upload: Upload
    for (var i = 0; i < event.target.files.length; i++) { 
      // this.budget.photos.push(event.target.files[i]);
      upload = new Upload(event.target.files[i]);
      this.uploadService.createUpload(upload, this.uploadPath);
      this.budget.photos.push(upload);
    }
  }

  get f(){
    return this.budgetForm.controls;
  }

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  public services = this._dataService.services

  public desplegado = false

  constructor(
    private http: HttpClient,
    private budgetService: BudgetService,
    private uploadService: UploadService,
    public _dataService : DatosService
  ) {}

  public printableSelectedItems() {
    return this.budget.services.map(el => `${el.service}, ${el.price}`);
  }

  private currentDate() {
    return new Date().toISOString().slice(0, 10);
  }

  desplegarSelect(){
    this.desplegado = !this.desplegado
  }

  selectService(service){
    let posicion = this.budget.services.indexOf(service)
    if( posicion === -1 ){
      this.budget.services.push(service)
    }else{
      this.budget.services.splice( posicion , 1)
    }
  }


  ngOnInit() {
    this.uploadPath = `uploads/${this.currentDate()}/${Math.random().toString(36).substring(2)}`;
  }
}
